export default "__VITE_ASSET__Et97nUxU__"